import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export function useGetChapterProgress(
  chapterId: number | string | undefined,
  enabled: boolean,
) {
  return useQuery(
    ['studyChapterProgress', chapterId],
    async () => {
      const response = await ChessRestClient.get(
        `/learning/study-chapter/${chapterId}/progress/`,
      );
      return response.data;
    },
    {
      enabled: Boolean(chapterId) && enabled,
      staleTime: 30_000,
    },
  );
}
